import { api } from '../core';
import { MEDICAL_MATCH_LIVE_STATUS_TAG } from '../constants';

export interface LiveMedicalMatchStalenessResponse {
  isStale: boolean;
}

interface GetLiveMedicalMatchStalenessRequest {
  caseId: string;
}

const getLiveMedicalMatchStalenessApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLiveMedicalMatchStaleness: builder.query<LiveMedicalMatchStalenessResponse, GetLiveMedicalMatchStalenessRequest>(
      {
        query: ({ caseId }: GetLiveMedicalMatchStalenessRequest) => ({
          url: `medical-match-custom/live-medmatch-staleness?caseId=${encodeURIComponent(caseId)}`,
          method: 'GET',
        }),
        providesTags: (_result, _err, { caseId }) => [{ type: MEDICAL_MATCH_LIVE_STATUS_TAG, id: caseId }],
        extraOptions: { maxRetries: 3 },
      },
    ),
  }),
});

export const { useGetLiveMedicalMatchStalenessQuery } = getLiveMedicalMatchStalenessApi;
